import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { useApproveKeyRiskMutation } from "store/slices/apis/keyRiskSlice";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";

export default function ApproveRiskComponent(props) {
  const { open, cancel, rowData, keys, refetch } = props;
  const theme = useTheme();
  const [approveKeyRisk] = useApproveKeyRiskMutation();
  const dispatch = useDispatch();

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const handleApprove = async () => {
    if (keys === "risk") {
      try {
        const response = await approveKeyRisk({ id: rowData?.risk_id });

        if (response?.data?.status === "success") {
          openNotification(
            response?.data?.message || "Risk approved successfully",
            "success"
          );
          cancel();
          refetch();
        } else {
          openNotification("Error in approve risk");
        }
      } catch (error) {
        openNotification(error?.error, "error");
      }
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={cancel}
        disableEnforceFocus
        disableRestoreFocus
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "20px",
            color: "#252525",
            paddingBottom: 0,
          }}
          id="draggable-dialog-title"
        >
          Approve
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          }}
        >
          <IoMdClose style={{ fontSize: "20px" }} />
        </IconButton>
        <DialogContent>
          {keys === "risk" ? (
            <DialogContentText
              sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
            >
              Are you sure you want to Approve this risk? This action is permanent.
            </DialogContentText>
          ) : (
            <DialogContentText
              sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
            >
              <TextField
                id="outlined-multiline-static"
                label="Comment (Optional)"
                name="Comment"
                multiline
                fullWidth
                rows={3}
                slotProps={{ inputLabel: { shrink: true } }}
                variant="filled"
              />
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={cancel}
            sx={{
              color: `${theme?.customSettings?.themeColor}`,
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
              border: `1px solid ${theme?.customSettings?.themeColor}`,
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleApprove}
            sx={{
              backgroundColor: `${theme?.customSettings?.themeColor}`,
              color: "#fff",
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
            }}
          >
            Approve
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
